import React from "react";
import "../csscontainer/Footer.css";
import "../App.css";
import { motion } from "framer-motion";
import Footer from "../components/Footer";
import Text from "../components/Text";
import { TEXT } from "../utility/constants";
import projManagement from "../assets/images/projManagement.png";
import sdwan from "../assets/images/sdwan2.png";
import wifi from "../assets/images/wifi.png";
import itad from "../assets/images/itad.png";
import avvc from "../assets/images/avvc.png";
import data from "../assets/images/data_center.png";
import appDev from "../assets/images/appDevelop.png";
import InfoBox from "../components/InfoBox";

function ProjectManagement() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="home-wrapper">
        {/* --- NEW SECTION FOR IMAGE ON RIGHT AND TEXT ON LEFT --- */}
        <div className="service-intro-section">
          <div className="service-intro-text">
            <Text
              color="black"
              size="32px"
              weight="bold"
              align="start"
              style={{ marginBottom: "15px" }}
            >
              {TEXT.ProjHeading}
            </Text>

            <Text
              color="#364040FF"
              size="18px"
              weight="normal"
              align="start"
              style={{ lineHeight: "1.6" }}
            >
              {TEXT.ProjDescription}
            </Text>
          </div>
          <div className="service-intro-image">
            <img
              src={projManagement} // Your IT service image
              alt="Diverse IT Service Projects and Solutions"
              className="responsive-service-image"
            />
          </div>
        </div>
        
        <div className="row-container-ib">
          <InfoBox
            imageSrc={sdwan}
            title={TEXT.sdwanHeading}
            description={TEXT.sdwanDesc}
            descriptionColor="#364040FF"
            showBorder={true}
          />
          <InfoBox
            imageSrc={wifi}
            title={TEXT.wifiHeading}
            description={TEXT.wifiDesc}
            descriptionColor="#364040FF"
            showBorder={true}
          />
        </div>
        <div className="row-container-ib">
          <InfoBox
            imageSrc={data}
            title={TEXT.dataHeading}
            description={TEXT.sdwanDesc}
            descriptionColor="#364040FF"
            showBorder={true}
          />
          <InfoBox
            imageSrc={avvc}
            title={TEXT.avvcHeading}
            description={TEXT.avvcDesc}
            descriptionColor="#364040FF"
            showBorder={true}
          />
        </div>
        <div className="row-container-ib">
          <InfoBox
            imageSrc={appDev}
            title={TEXT.appDevHeading}
            description={TEXT.appDevDesc}
            descriptionColor="#364040FF"
            showBorder={true}
          />
          <InfoBox
            imageSrc={itad}
            title={TEXT.itadHeading}
            description={TEXT.itadDesc}
            descriptionColor="#364040FF"
            showBorder={true}
          />
        </div>
        <Footer />
      </div>
    </motion.div>
  );
}
export default ProjectManagement;
